import React from 'react';
import PropTypes from 'prop-types';

import { BFLoader } from '@components/common/loader/main';

export default class ImagePreview extends React.Component {
  state = {
    isLoadingiFrame: true,
  }

  render() {
    const { isLoadingiFrame } = this.state;
    const { imageUrls, pdfUrl } = this.props;
    const displayiFrameClass = isLoadingiFrame ? 'hide-iframe' : '';

    if (imageUrls && imageUrls.length === 1) {
      return (
        <img
          alt="print preview"
          className="preview-image"
          src={imageUrls[0]}
        />
      );
    }

    return (
      <React.Fragment>
        {isLoadingiFrame ? <BFLoader /> : null }
        <iframe
          src={pdfUrl}
          className={`preview-iframe ${displayiFrameClass}`}
          onLoad={() => this.setState({ isLoadingiFrame: false })}
          title="pdf preview"
        >
          <p>{t('Your browser does not support iframes.')}</p>
        </iframe>
      </React.Fragment>
    );
  }
}

ImagePreview.propTypes = {
  pdfUrl: PropTypes.string,
  imageUrls: PropTypes.PropTypes.arrayOf(PropTypes.string),
};

ImagePreview.defaultProps = {
  pdfUrl: '',
  imageUrls: null,
};
